export default "__VITE_ASSET__86d8a18f__"